import React from 'react';
import { Body5, Body7 } from '@ui';
import { StatusPill } from './StatusPill';
import { formatCatalogStatus, formatCount, EM_DASH } from './format';
import { CATALOG_STATUS_TOKENS, tokenFor } from './statusTokens';
import { HeaderCell, HeaderRow, Mono, Row, Table, TableScroll, rowKeyHandler } from './styles';
import { itemAliases } from './CatalogItemForm';

// Code | Label | Section | Value kind · units | Aliases | Required | Status
const GRID_COLUMNS =
  'minmax(170px, 1.6fr) minmax(190px, 2fr) minmax(140px, 1.4fr) minmax(130px, 1.2fr) minmax(70px, 0.6fr) minmax(90px, 0.8fr) minmax(100px, 0.9fr)';

const rowAriaLabel = (item) =>
  `${item.canonical_item_label || item.canonical_item_code}, ${item.canonical_item_code}, ${formatCatalogStatus(
    item.status
  )}`;

export const CatalogItemsTable = ({ items, onOpen }) => (
  <TableScroll>
    <Table $minWidth={940}>
      <HeaderRow $columns={GRID_COLUMNS}>
        <HeaderCell>Code</HeaderCell>
        <HeaderCell>Label</HeaderCell>
        <HeaderCell>Section</HeaderCell>
        <HeaderCell>Value kind · units</HeaderCell>
        <HeaderCell>Aliases</HeaderCell>
        <HeaderCell>Required</HeaderCell>
        <HeaderCell>Status</HeaderCell>
      </HeaderRow>
      {items.map((item) => {
        const aliases = itemAliases(item);
        return (
          <Row
            key={item.canonical_item_code}
            $columns={GRID_COLUMNS}
            $interactive
            role="button"
            tabIndex={0}
            onClick={() => onOpen(item)}
            onKeyDown={rowKeyHandler(() => onOpen(item))}
            aria-label={rowAriaLabel(item)}
          >
            <Mono>{item.canonical_item_code}</Mono>
            <Body5 bold>{item.canonical_item_label || EM_DASH}</Body5>
            <div>
              <Body7>{item.section || EM_DASH}</Body7>
              {item.sub_section && (
                <div>
                  <Body7 isLowContrast>{item.sub_section}</Body7>
                </div>
              )}
            </div>
            <div>
              <Body7>{item.default_value_kind || EM_DASH}</Body7>
              {item.default_units && (
                <div>
                  <Body7 isLowContrast>{item.default_units}</Body7>
                </div>
              )}
            </div>
            <Body7 isLowContrast title={aliases.length ? aliases.join('; ') : undefined}>
              {formatCount(aliases.length)}
            </Body7>
            <Body7 isLowContrast>{item.required_level || EM_DASH}</Body7>
            <div>
              <StatusPill
                token={tokenFor(CATALOG_STATUS_TOKENS, item.status)}
                label={formatCatalogStatus(item.status)}
              />
            </div>
          </Row>
        );
      })}
    </Table>
  </TableScroll>
);
